import { type FC, type ReactNode } from 'react';

import { hasEnabledFeature } from '@vakantiesnl/components/src/atoms/FeatureToggle/utils';
import { useFeatures } from '@vakantiesnl/services/src/stores/applicationStore';

type Props = {
	name: string;
	children: ReactNode;
	defaultChildren?: ReactNode;
};

const FeatureToggle: FC<Props> = ({ name, children, defaultChildren = null }) => {
	const features = useFeatures();

	const isEnabled = hasEnabledFeature(features, name);

	return <>{isEnabled ? children : defaultChildren}</>;
};

export { FeatureToggle };
